module.exports = __webpack_public_path__ + "static/media/resume-select.b9bb34cc.svg";